import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';
import SearchIcon from '@mui/icons-material/Search';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const FiltroMercadoPago = ({ handleSubmit, onSubmit, register, errors }) => {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={1} alignItems='center'>
        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Número de operación'
            {...register('mercadopago_payment_id')}
            error={Boolean(errors.mercadopago_payment_id)}
            helperText={errors.mercadopago_payment_id?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Referencia externa'
            {...register('external_reference')}
            error={Boolean(errors.external_reference)}
            helperText={errors.external_reference?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Tarjeta'
            {...register('card_last_digits')}
            error={Boolean(errors.card_last_digits)}
            helperText={errors.card_last_digits?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Correo electrónico'
            {...register('email')}
            error={Boolean(errors.email)}
            helperText={errors.email?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <TextField
            fullWidth
            label='Monto'
            type='number'
            {...register('amount')}
            error={Boolean(errors.amount)}
            helperText={errors.amount?.message}
            onWheel={(e) => e.target.blur()}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1.5 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FiltroMercadoPago;
